import { useSyncExternalStore } from "react";
import { getVideoPrefs, setVideoPref, useVideoPrefs } from "@/lib/videoPrefs";

/* Theater mode: while a video page is open and the (synced) preference is on, Layout hides the sidebar, top bar and music player. */
let active = false;
const subs = new Set();
const subscribe = (fn) => { subs.add(fn); return () => subs.delete(fn); };

export const setTheaterActive = (on) => { if (active !== !!on) { active = !!on; subs.forEach((fn) => fn()); } };
export const toggleTheaterPref = () => setVideoPref({ theater: !getVideoPrefs().theater });
export const useTheater = () => {
  const prefs = useVideoPrefs();
  const isActive = useSyncExternalStore(subscribe, () => active);
  return !!prefs.theater && isActive;
};
